module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('article', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('div', {
    staticClass: "bodymatter",
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('section', {
    attrs: {
      "epub:type": "division"
    }
  }, [_c('h1', {
    staticClass: "chapter_fm1",
    attrs: {
      "id": "c05"
    }
  }, [_c('span', {
    staticClass: "chapter_fm1"
  }, [_vm._v("c. 1200 BCE")])]), _vm._v(" "), _c('h1', {
    staticClass: "chapter"
  }, [_vm._v("Purification")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Who was the first chemist whose name we know? That record is currently held by Tapputi, a palace overseer and perfume maker mentioned on a Babylonian tablet from about 1200 BCE. The cuneiform text describes her using various scented raw materials (myrrh, balsam, and the like), filtering off impurities, and heating the results in water to collect the vapors. That also makes this tablet the oldest reference to distillation and filtration—processes that are still familiar to every working chemist today.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The science of scent has been the engine of more chemical discovery than you might think. Human civilization has cared about attractive smells for a very long time, and we’ve learned a lot about "), _c('strong', [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/c10"
    }
  }, [_vm._v("natural-product")])]), _vm._v(" chemistry in the process. Long before anyone knew how to use chemistry to produce useful medicines, ancient chemists produced high-value perfumes (which were often considered medicinal as well). Many techniques were developed to extract and concentrate essences from flowers, barks, seeds, and other sources. Some of these extracts can stand up to heat (as with distillation) and be concentrated that way, but delicate extracts have to be purified at lower temperatures. This led to experiments with different kinds of solvents and separations, such as soaking aromatic plants in oils or alcoholic solutions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It seems likely that Tapputi would quickly grasp the concepts behind a modern "), _c('strong', [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/c175",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("rotary evaporator")])]), _vm._v(" and could surely put one to good use. We know almost nothing about her besides what is found on this single tablet. But it’s enough.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("An entire Bronze Age perfume factory has been excavated in Cyprus, showing how valuable this sort of work was in the ancient world. Modern perfume factories largely use synthetic molecules (starting with the groundbreaking "), _c('strong', [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/c82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fougère Royale")])]), _vm._v(" blend) with costly natural extracts reserved for the most expensive items in the catalog.")]), _vm._v(" "), _c('p', {
    staticClass: "seealso"
  }, [_c('strong', [_vm._v("SEE ALSO")]), _vm._v(" "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/c10"
    }
  }, [_vm._v("Natural Products (c. 60 CE)")]), _vm._v(", "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/c19"
    }
  }, [_vm._v("Fractional Distillation (c. 1280)")]), _vm._v(", "), _c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/c64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Separatory Funnel (1854)")]), _vm._v(", "), _c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/c82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fougère Royale (1881)")]), _vm._v(", "), _c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/c109",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chromatography (1901)")]), _vm._v(", "), _c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/c183",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Zone Refining (1952)")]), _vm._v(", "), _c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/c175",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rotary Evaporator (1950)")]), _vm._v(", "), _c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/c196",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Isoamyl Acetate and Esters (1962)")])]), _vm._v(" "), _c('div', {
    staticClass: "image"
  }, [_c('div', {
    staticClass: "dis_img"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "Images/023.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Earlier than Tapputi’s time, this Fourth Dynasty (c. 2500 BCE) Egyptian tomb decoration shows the making of lily-scented perfume using methods the Babylonians would have known well.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e87f83b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/c05.vue
// module id = 90
// module chunks = 0